/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description EditPaymentAllocation Button
 */
import { Button as AntButton, ButtonProps } from 'antd';

import { Link } from 'react-router-dom';
import { getPaymentAllocationPath } from 'utils/router';

/**
 * EditPaymentAllocation Button
 */

const EditPaymentAllocation: React.FC<Record<'id', string> & ButtonProps> = ({ id, ...restProps }) => {
	return (
		<Link {...restProps} to={getPaymentAllocationPath(id)}>
			<AntButton {...restProps}>{'View/Edit Allocation'}</AntButton>
		</Link>
	);
};

export default EditPaymentAllocation;
